import { Fragment } from "react";
import { HeaderMall9 } from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import BookingListContext, {
  BookingListController,
  useBookingListContext,
} from "../../../../reducer/moduleReducer/bookingList";
import { useEffect } from "react";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import { getI18n, useTranslation } from "react-i18next";
import { mediaMatch } from "../../../../utils";
import cookies from "../../../../utils/cookies";

function BookingListWrap() {
  const { state } = useBookingListContext();
  const { getBannerList, getBookingList, gotoBookingDetail, setTabsActive } =
    BookingListController();
  const { bannerList, bookingList, tabActive } = state;
  const { t } = useTranslation();
  const lang = getI18n().language;

  useEffect(() => {
    getBannerList();
    getBookingList();
  }, []);
  return (
    <Navigator.container className="mobile">
      <h1 className="md:mt-[35px] md:mb-[20px] mdmax:hidden text-[22px] font-bold">
        {t("预约列表")}
      </h1>
      {bannerList.length > 0 && (
        <img
          src={bannerList[0].contentList[0].mainPicView}
          width="100%"
          className="mdmax:mt-[10px]"
        />
      )}
      <div className="mdmax:hidden md:pb-[55px]">
        {bookingList.map((item, i) => (
          <Fragment key={i}>
            <h2 className="text-xl text-center mt-[80px] mb-[40px]">
              {lang === 'en'? item.firstTypeEnName:item.firstTypeName}
            </h2>
            <div className="grid grid-cols-3 gap-12">
              {item.infoLisst.map((child, index) => (
                <div
                  className="text-center cursor-pointer col-span-1 grid grid-rows-1"
                  onClick={() => gotoBookingDetail(child)}
                  key={index}
                >
                  <div className="row-span-1 flex items-center max-h-[438px] overflow-hidden">
                    <img
                      src={child.mainPicView}
                      style={{ width: "100%" }}
                      className="block"
                    />
                  </div>
                  <p className="text-[14px] py-[15px] bg-white">
                    {lang === "en" ? child.titleEn : child.title}
                  </p>
                </div>
              ))}
            </div>
          </Fragment>
        ))}
      </div>

      <div className="md:hidden mdmax:pb-[20px]">
        <div className="flex my-[20px] items-center">
          {bookingList.map((item, i) => (
            <a
              key={i}
              onClick={() => setTabsActive(i)}
              className={`text-[#999] relative px-[20px] ${
                i === tabActive
                  ? "text-black font-bold text-[15px] text-[#ECBC40]"
                  : "text-[15px]"
              }`}
            >
              {lang === 'en'? item.firstTypeEnName:item.firstTypeName}
              {i === tabActive && (
                <i
                  className="absolute bg-[#ECBC40] h-[3px] w-[18px] rounded-full bottom-[-5px] left-[50%]"
                  style={{ transform: "translateX(-50%)" }}
                />
              )}
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-4">
          {bookingList.length > 0 &&
            bookingList[tabActive].infoLisst.map((child, index) => (
              <div
                className="relative overflow-hidden rounded-[10px] p-[15px] bg-white "
                style={{ boxShadow: "0 2px 8px rgba(0,0,0,.1)" }}
                onClick={() => gotoBookingDetail(child)}
                key={index}
              >
                <img src={child.mainPicView} style={{ width: "100%" }} />
                <div className="container py-[15px] pb-0 text-[15px]">
                  {lang === "en" ? child.titleEn : child.title}
                </div>
              </div>
            ))}
        </div>
      </div>
    </Navigator.container>
  );
}

export default function BookingList() {
  const isMdmax = mediaMatch.isMdmax;
  const agentInfo = cookies.getAgentInfo();

  return (
    <div
      className="bg-[#f0f0f0]"
      style={{ minHeight: isMdmax ? window.innerHeight : "auto" }}
    >
      <HeaderMall9
        customFloatHeader={true}
        type={agentInfo.isProduct === "0" ? "bookinglist" : ""}
      />
      {agentInfo.isProduct !== "0" ? (
        <Navigator title="预约服务" goback />
      ) : null}
      <BookingListContext>
        <BookingListWrap />
      </BookingListContext>
      <FooterMall9 noTabs />
    </div>
  );
}
